<template>
	<div>
		<Header :active="1"></Header>
		<div class="searchDiv">
			<div class="content">
				<div class="position">
					当前位置：
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item :to="{ path: '/' }">网站首页</el-breadcrumb-item>
						<el-breadcrumb-item>选择城市</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</div>
		</div>
		<div class="citys-div">
			<div class="content">
				<div class="Commonly-used">
					<div class="left">
						常用城市
					</div>
					<div class="list">
						<div @click="commonlyClick(index,item)" :class="{on:commonlyOn==index}"
							v-for="(item,index) in commonlyUsed" :key="index">{{item}}</div>
					</div>
				</div>
				<div class="Initials">
					<div class="title">
						按首字母查找
					</div>
					<div class="Initials-list">
						<div v-for="(item,index) in InitialsLisr" :key="index" class="list">
							<div class="left">
								{{item.code}}
							</div>
							<div class="right">
								<div @click="InitialsClick(item2)" v-for="(item2,index2) in item.cityList"
									:key="index2">{{item2}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from '../components/subHead.vue'
	import area from '../assets/areaSortA.json'
	export default {
		name: "citys",
		components: {
			Header
		},
		data() {
			return {
				commonlyUsed: ['全国', '长沙市', '北京市', '上海市', '深圳市', '广州市', '杭州市', '成都市', '南京市', '武汉市', '西安市', '厦门市', '苏州市', '天津市'],
				commonlyOn: 0,
				InitialsLisr: []
			}
		},
		mounted() {
			this.InitialsLisr = area;
		},
		methods: {
			commonlyClick(i, data) {
				this.commonlyOn = i;
				this.$router.push({
					path: './jobHunting',
					query: {
						city: data
					}
				})
			},
			InitialsClick(data) {
				this.$router.push({
					path: './jobHunting',
					query: {
						city: data
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.citys-div {
		.Initials {
			.Initials-list {
				.list {
					.right {
						.on:hover {
							color: #FFFFFF !important;
						}

						.on {
							background-color: #00BCD4;
							color: #FFFFFF;
						}

						div:hover {
							color: #00BCD4;
						}

						div {
							padding: 0 12px;
							cursor: pointer;
							border-radius: 4px;
							margin-bottom: 10px;
						}

						display: flex;
						flex-wrap: wrap;
					}

					.left {
						flex-shrink: 0;
						margin-right: 30px;
						width: 30px;
						height: 30px;
						background-color: #F8F8F8;
						font-size: 14px;
						color: #666666;
						text-align: center;
						line-height: 30px;
						margin-top: 2px;
					}

					display: flex;
					margin-bottom: 30px;
				}
			}

			.title {
				font-size: 16px;
				color: #333333;
				margin: 30px 0;
			}
		}

		.Commonly-used {
			.on:hover {
				color: #FFFFFF !important;
			}

			.on {
				background-color: #00BCD4;
				color: #FFFFFF;
			}

			.list {
				div:hover {
					color: #00BCD4;
				}

				div {
					padding: 6px 12px;
					cursor: pointer;
					border-radius: 4px;
				}

				display: flex;
				flex-wrap: wrap;
			}

			.left {
				flex-shrink: 0;
				margin-right: 20px;
			}

			display: flex;
			align-items: center;
			font-size: 14px;
			color: #666666;
		}

		background-color: #FFFFFF;
		padding: 30px 0;
	}

	.searchDiv {
		/deep/.el-breadcrumb__item .is-link {
			font-weight: 400!important;
		}
		/deep/.el-breadcrumb__inner:hover{
			color: #00BCD4;
		}
		/deep/.el-breadcrumb__inner{
			color: #999999;
		}
		.position {
			font-size: 14px;
			color: #999999;
			display: flex;
			align-items: center;
		}

		width: 100%;
		background-color: #FBFBFB;
		padding: 30px 0;
	}

	.content {
		width: 1200px;
		margin: auto;
	}
</style>
